var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers",
            staticStyle: { margin: "10px" }
          },
          [
            _c(
              "el-button",
              {
                attrs: { disabled: !_vm.innerIsEditing, type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.showEditDialog(true)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.NewGoods")))]
            ),
            _c(
              "el-button",
              {
                attrs: { disabled: !_vm.innerIsEditing, type: "danger" },
                on: { click: _vm.remove }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteGoods")))]
            ),
            _c(
              "div",
              { staticClass: "calculation", staticStyle: { float: "right" } },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("SeaExport.TotalOfThisBox")))
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.Quantity")) +
                      "：" +
                      _vm._s(_vm.quantity)
                  )
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.Weight")) +
                      "：" +
                      _vm._s(_vm.weight)
                  )
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("SeaExport.Cubage")) +
                      "：" +
                      _vm._s(_vm.cubage)
                  )
                ])
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: {
                width: "100%",
                height: "200px",
                "margin-top": "5px"
              },
              attrs: {
                "config-module": "13011501",
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.finalRowData
              },
              on: { gridReady: _vm.onGridReady }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("el-input", {
            attrs: { disabled: !_vm.isEditing, type: "textarea", rows: "10" },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditing,
                      expression: "isEditing"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }